import styled, { css } from 'styled-components';

import { TextButton } from '@xing-com/button';
import { spaceXS, xdlColorTextSecondary } from '@xing-com/tokens';

// *** Base ***
const baseViewCounter = css`
  color: ${xdlColorTextSecondary};
  margin-left: auto;
  & span {
    margin-right: ${spaceXS};
  }
`;

// *** Components ***
const ViewCounter = styled(TextButton)`
  ${baseViewCounter}
`;

export const Styled = {
  ViewCounter,
};
